import type { Page } from '@/types/learn'

/**
 * The translated description to show over a lesson page's image, or `null` for no panel.
 *
 * One place rather than two. The rule used to be spelled out at each call site and the two
 * copies had already drifted: the lesson carousel required `web_foreground` while the feed
 * card required `item.type === 'lesson'`, and neither matched what `LessonViewContent.Img`
 * actually renders, which is `mobile_foreground || web_foreground`. A page carrying only a
 * mobile image therefore showed the image on a narrow viewport and never its caption.
 *
 * `has_translated_image` is the reason a page can have alt text and still show no panel: when
 * the backend has a translated version of the image itself, the words are already on screen in
 * the reader's language and repeating them below is noise.
 */
export const getPageTranslationText = (page?: Page): string | null => {
  const hasImage = !!(page?.mobile_foreground || page?.web_foreground)

  if (!hasImage || !page?.image_alt_text || page?.has_translated_image) return null

  return page.image_alt_text
}
